import styles from './browse-filter-bar.module.css'

import React, { useCallback } from 'react'

import { applyBrowseFilters } from '@disco/state-management/actions/SearchActions'
import { selectSearchPage } from '@disco/state-management/reducers/search-page'
import { getSearch } from '@disco/state-management/selectors/search'

import type { FilterState } from 'types/filter-page'

import { Flex } from 'components/ds'

import { useDispatch, useSelector } from 'hooks/use-redux'

import FilterBar from './filter-bar'

/**
 * STL-1250: binds the shared filter bar to Browse, whose search term still
 * lives on the legacy slice until the input is migrated.
 */
const BrowseFilterBar = (): React.ReactNode => {
  const dispatch = useDispatch()
  const { filters } = useSelector(selectSearchPage)
  const search = useSelector(getSearch)

  const applyFilters = useCallback(
    (value: FilterState[]) => {
      dispatch(applyBrowseFilters(value))
    },
    [dispatch],
  )

  return (
    <Flex
      className={styles.browseFilterBar}
      wrap="wrap"
      gap="2"
      align="center"
      minWidth="0"
    >
      <FilterBar
        filters={filters}
        hasQuery={Boolean(search.searchTerm)}
        seedFixedFilters={false}
        onChange={applyFilters}
        onClearAll={applyFilters}
      />
    </Flex>
  )
}

export default BrowseFilterBar
